import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const CUSTOM_KPIS_KPIS_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "CUSTOM_KPIS_MENU",
  path: "kpis",
  description: "CONF_DESC_CUSTOM_KPIS",
  model: {
    entityName: "label",
    label: "CUSTOM_KPIS_MENU",
    path: "/api/kpis",
    name: "Custom KPIs",
    enableTableColumnMenu: true,
    queryParams: {
      ordering: "is_system,id",
    },
    attributes: [
      {
        key: "label",
        order: 1,
        label: "KPI_LABEL",
        visible: true,
      },
      {
        key: "code",
        order: 2,
        label: "KPI_CODE",
        visible: true,
        hideable: true,
      },
      {
        key: "kpi_type.label",
        order: 3,
        label: "KPI_TYPE",
        visible: true,
        hideable: true,
      },
      {
        key: "is_system",
        order: 4,
        label: "KPI_IS_SYSTEM",
        type: FormatType.BOOLEAN,
        visible: true,
      },
      {
        key: "formula",
        order: 5,
        label: "KPI_FORMULA",
        visible: true,
        tooltip: true,
      },
      {
        key: "description",
        order: 6,
        label: "KPI_DESCRIPTION",
        visible: true,
        hideable: true,
        tooltip: true,
      },
      {
        align: "right",
        key: "updated_at",
        order: 7,
        label: "UPDATED_AT",
        type: FormatType.DATE,
        visible: false,
        hideable: true,
      },
      {
        key: "updated_by",
        order: 8,
        label: "UPDATED_BY",
        visible: false,
        hideable: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    actions: [
      {
        type: "trigger",
        api: "/api/kpis/recompute/",
        label: "RECOMPUTE_CUSTOM_KPIS",
      },
    ],
  },
  options: {
    formFields: [
      {
        key: "label",
        label: "KPI_LABEL",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/kpi-types/",
        apiParams: {
          page_size: 100,
          ordering: "label",
        },
        key: "kpi_type",
        label: "KPI_TYPE",
        labelKey: "label",
      },
      {
        key: "format_preset",
        label: "KPI_FORMAT",
        type: ConfigurationFormType.StaticSelect,
      },
      {
        key: "formula",
        label: "KPI_FORMULA",
        type: ConfigurationFormType.TextArea,
      },
      {
        key: "description",
        label: "KPI_DESCRIPTION",
        type: ConfigurationFormType.TextArea,
      },
    ],
    creatable: true,
    createOptions: [
      {
        key: "label",
        flex: "100%",
        required: true,
      },
      {
        key: "kpi_type",
        flex: "100%",
        required: true,
      },
      {
        key: "format_preset",
        flex: "100%",
        required: true,
      },
      {
        key: "formula",
        flex: "100%",
        required: true,
      },
      {
        key: "description",
        flex: "100%",
        required: false,
      },
    ],
    copyable: false,
    editable: (row) => !row.is_system,
    editOptions: [
      {
        key: "label",
        flex: "100%",
        required: true,
      },
      {
        key: "kpi_type",
        flex: "100%",
        required: true,
      },
      {
        key: "format_preset",
        flex: "100%",
        required: true,
      },
      {
        key: "formula",
        flex: "100%",
        required: true,
      },
      {
        key: "description",
        flex: "100%",
        required: false,
      },
    ],
    deletable: (row) => !row.is_system,
  },
};

const CUSTOM_KPIS_ATOMS_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "KPI_ATOMS_TAB",
  path: "atoms",
  description: "CONF_DESC_KPI_ATOMS",
  model: {
    entityName: "name",
    label: "KPI_ATOMS_TAB",
    path: "/api/kpi-atoms",
    name: "KPI Atoms",
    enableTableColumnMenu: true,
    attributes: [
      {
        key: "name",
        order: 1,
        label: "KPI_ATOM_NAME",
        visible: true,
      },
      {
        key: "description",
        order: 2,
        label: "KPI_ATOM_DESCRIPTION",
        visible: true,
        tooltip: true,
      },
      {
        key: "offset_mode",
        order: 3,
        label: "KPI_ATOM_OFFSET_MODE",
        visible: true,
        hideable: true,
      },
      {
        key: "named_params",
        order: 4,
        label: "KPI_ATOM_NAMED_PARAMS",
        visible: true,
        hideable: true,
      },
      {
        key: "supported_grains",
        order: 5,
        label: "KPI_ATOM_SUPPORTED_GRAINS",
        visible: false,
        hideable: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
  },
  options: {
    formFields: [],
    creatable: false,
    copyable: false,
    editable: false,
    deletable: false,
  },
};

export const CUSTOM_KPIS_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  name: "Custom KPIs",
  label: "CUSTOM_KPIS_MENU",
  menuLabel: "CUSTOM_KPIS_MENU",
  pageLabel: "CUSTOM_KPIS_TITLE",
  path: "custom-kpis",
  hideInMenu: true,
  isStaff: true,
  tabs: [CUSTOM_KPIS_KPIS_TAB, CUSTOM_KPIS_ATOMS_TAB],
};
